import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Card from "../../../components/Card";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Import images
import robotics from "../../../assets/images/upcomingCourse/robotics_program.png";
import robotics_l from "../../../assets/images/upcomingCourse/robotics1.png";
import profilebg8 from "../../../assets/images/page-img/profile-bg8.jpg";

// Import profile header component
import ProfileHeader from "../../../components/profile-header";
import axios from "axios";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import Loading from "../../../components/common/Loading";
import { Oval } from "react-loader-spinner";

const courseData = [
  {
    id: 1,
    title: "Post Graduate Teacher",
    img: robotics,
    date: "10-Mar-2025 to 14-Mar-2025",
    time: "9am to 2pm",
    venue: "Tech Park, Sector 62, Noida.",
    link: "/lesson-plan/PGT",
    large_image: robotics_l,
  },
  {
    id: 2,
    title: "Trained Graduate Teacher",
    img: robotics_l,
    date: "10-Mar-2025 to 14-Mar-2025",
    time: "9am to 2pm",
    venue: "Tech Park, Sector 62, Noida.",
    link: "/lesson-plan/TGT",
    large_image: robotics_l,
  },
  // {
  //   id: 3,
  //   title: "AI Program",
  //   img: ai,
  //   date: "10-Mar-2025 to 14-Mar-2025",
  //   time: "9am to 2pm",
  //   venue: "Tech Park, Sector 62, Noida.",
  //   link: "/dashboards/store/product-detail",
  //   large_image:ai_l
  // },
  // {
  //   id: 4,
  //   title: "MERN Stack Program",
  //   img: store3,
  //   date: "10-Mar-2025 to 14-Mar-2025",
  //   time: "9am to 2pm",
  //   venue: "Tech Park, Sector 62, Noida.",
  //   link: "/dashboards/store/product-detail",
  // },
  // {
  //   id: 5,
  //   title: "Java Development Program",
  //   img: store4,
  //   date: "10-Mar-2025 to 14-Mar-2025",
  //   time: "9am to 2pm",
  //   venue: "Tech Park, Sector 62, Noida.",
  //   link: "/dashboards/store/product-detail",
  // },
  // {
  //   id: 6,
  //   title: "Machine Learning Program",
  //   img: store5,
  //   date: "10-Mar-2025 to 14-Mar-2025",
  //   time: "9am to 2pm",
  //   venue: "Tech Park, Sector 62, Noida.",
  //   link: "/dashboards/store/product-detail",
  // },
];

let res = [
  {
    title: "Programme Orientation",
  },
  // {
  //   title: "LMS Orientation",
  // },
  {
    title: "Pre-Assessment",
  },
  {
    title: "Pre-Training Feedback",
  },
  {
    title: "Programme Documents",
  },
];

const LessonPlans = () => {
  const [dataLoading, setDataLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState(JSON.parse(localStorage.getItem("users")));
  const [courses, setCourses] = useState([]);
  console.log(courses[0]?.school_code, "pressings???????");
  useEffect(() => {
    getEnrolledCourses();
  }, []);

  const getEnrolledCourses = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(webServiceUrl.allPrograms, {
        users,
      });
      console.log(response, "pressings");
      setCourses(response?.data?.allPrograms);
      await localStorage.setItem(
        "school_code",
        response?.data?.allPrograms[0]?.school_code,
      );
    } catch (error) {
      console.error(error, "ERROR coming From  getallPrograms ");
      setCourses([]);
    } finally {
      setTimeout(() => setIsLoading(false), 1500);
    }
  };

  useEffect(() => {
    // const timer = setTimeout(() => setIsLoading(false), 400);
    setUsers(JSON.parse(localStorage.getItem("users")));
    // return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 1500);
  }, []);

  // console.log(courses)

  return (
    <div
      id="content-page"
      className=""
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      {res?.map((item, index) => {
        return (
          <Link
            to={
              item?.title == "Programme Orientation"
                ? `/lesson-plan/programme-Journey`
                : item?.title == "LMS Orientation"
                  ? `/lesson-plan/LMSOrientation`
                  : item?.title == "Pre-Assessment"
                    ? `/assginMent`
                    : item?.title == "Pre-Training Feedback"
                      ? `/preTraningFeedback`
                      : `/ProgrammeDocuments`
            }
            // state={{ courses }}
            className="col-12 col-sm-6 col-xl-4"
          >
            <div>
              <div
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "10px",
                  padding: "16px",
                  background: "#fff",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  // gap: "10px",
                  marginRight: "10px",
                  marginTop: "10px",
                  marginLeft: "10px",
                }}
              >
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "#2e7d32",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  {index + 1}
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "10px",
                      color: "#bbb",
                      marginBottom: "2px",
                    }}
                  >
                    Step {index + 1}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#222",
                    }}
                  >
                    {item?.title}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#888",
                    lineHeight: "1.5",
                    flex: 1,
                  }}
                >
                  Evaluator reviews and scores your TOP after the training
                  session.
                </div>
              </div>
            </div>
          </Link>
        );
      })}
      {/* {isLoading
        ? <>
          <div
            className="d-flex justify-content-center "
            style={{ height: "85vh", paddingTop: "15vh" }}
          >
            <Oval
              height="50"
              width="50"
              color="#4fa94d"
              secondaryColor="#4fa94d"
            />
          </div>
        </>
        : (
          <>
            <ProfileHeader img={profilebg8} />
            <div
              id="content-page"
              className="content-inner store-details upcoming-card pt-4 mt-0"
            >
              <Container>
                <Row>
                  <div
                    className="header-title mb-4"
                    style={{ textAlign: "left", width: "100%" }}
                  >
                    <h1
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      About Program
                    </h1>
                  </div>
                  {isLoading
                    ? Array.from({ length: 2 }).map((_, index) => (
                      <Col sm="6" md="6" lg="4" key={index}>
                        <Skeleton height={250} className="rounded-3" />
                        <Skeleton height={20} width="80%" className="mt-2" />
                        <Skeleton height={15} width="90%" />
                        <Skeleton height={15} width="70%" />
                        <Skeleton height={15} width="50%" />
                      </Col>
                    ))
                    : courses?.map?.((item) => (
                      <Col sm="6" md="6" lg="4" key={item.id}>
                        <div className="mx-3">
                          <CourseCard course={item} />
                        </div>
                      </Col>
                    ))}
                </Row>
              </Container>
            </div>
          </>
        )
      } */}
    </div>
  );
};

const CourseCard = ({ course, dataLoading }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2300);
    return () => clearTimeout(timer);
  });
  return (
    <Link
      to={`/lesson-plan/${course?.school_code}`}
      // state={{course}}
      onClick={() => {
        localStorage.setItem("upcomingCourse", JSON.stringify(course));
      }}
    >
      <Card className="card-block card-stretch card-height product">
        <div
          style={{
            boxShadow:
              "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
            borderRadius: "10px",
          }}
        >
          <Card.Body>
            {/* <div className="image-block position-relative productCardImg overflow-hidden p-3 d-flex align-items-center justify-content-center rounded-3 border">
              {dataLoading && <Skeleton height={100} className="rounded-3" />}
              <img
                src={course?.logo_image}
                // className="img-fluid w-100 h-100 object-fit-cover rounded border"
                className="img-fluid group-detail-post-imag object-fit-cover rounded "
                alt="product-img"
                style={{ display: dataLoading ? "none" : "block" }}
              // onLoad={() => setLoading(false)}
              />
            </div> */}

            {/* <div className="image-block position-relative productCardImg overflow-hidden">
              {loading && <Skeleton height={200} className="rounded-3" />}
              <div className="h-100 w-100 d-flex align-items-center justify-content-center">
                <img
                  src={course?.logo_image}
                  className="img-fluid group-detail-post-image object-fit-cover rounded"
                  alt="product-img"
                  style={{ display: loading ? "none" : "block" }}
                // onLoad={() => setLoading(false)}
                />
              </div>
            </div> */}

            <div className="image-block position-relative productCardImg overflow-hidden">
              {loading && <Skeleton height={200} className="rounded-3" />}

              <div className="h-100 w-100 d-flex align-items-center justify-content-center">
                <img
                  src={course?.logo_image}
                  className="rounded"
                  alt="product-img"
                  style={{
                    display: loading ? "none" : "block",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain", // ⭐ important
                  }}
                  onLoad={() => setLoading(false)}
                />
              </div>
            </div>
            {/* <h6 className="price cursor-pointer secondaryBG ">Enroll Now</h6> */}

            <div className="product-description mt-3 d-flex flex-column gap-1">
              <div
                className="mb-1 px-2"
                style={{ fontSize: "19px", fontWeight: "600" }}
              >
                {course?.school_name}
              </div>
              {/* <p className="categry secondary-color ps-3 mb-0 position-relative mb-0">
                In-person course - 5 days
              </p> */}
              {/* <p className="mb-0">📅 {course?.date}</p> */}
              {/* <p className="mb-0">🕗 {course?.time}</p>
              <p className="mb-0">📍 Venue: {course?.venue}</p> */}
            </div>
          </Card.Body>
        </div>
      </Card>
    </Link>
  );
};

export default LessonPlans;
